export default __webpack_public_path__ + "static/gameTiles-d18586968d0b0d2b4ce5ac96718628a5.png";